import { useFaireDirectMarketplaceIncentiveBannerTextContent } from "@faire/deprecated-retailer-visitor-shared/components/Notifications/Components/FaireDirectIncentivesBanner/FaireDirectMarketplaceIncentiveBanner/__internal__/useFaireDirectMarketplaceIncentiveBannerTextContent";
import { useFaireDirectMarketplaceIncentiveBannerViewDetailsHandleClick } from "@faire/deprecated-retailer-visitor-shared/components/Notifications/Components/FaireDirectIncentivesBanner/FaireDirectMarketplaceIncentiveBanner/__internal__/useFaireDirectMarketplaceIncentiveBannerViewDetailsHandleClick";
import { useStrictLocalization } from "@faire/web/common/localization/localize";
import { Button } from "@faire/web/slate/Button";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";

export const FaireDirectMarketplaceIncentiveBanner: React.FC = () => {
  const { strictLocalize } = useStrictLocalization();

  const handleClick =
    useFaireDirectMarketplaceIncentiveBannerViewDetailsHandleClick();
  const header = useFaireDirectMarketplaceIncentiveBannerTextContent();

  return (
    <Typography
      align="center"
      data-test-id="faire-direct-marketplace-incentive-banner"
    >
      {header}{" "}
      <Button variant="tertiary" onClick={handleClick}>
        {strictLocalize({
          id: "Zxul5c",
          defaultMessage: "View details",
          description: {
            text: "CTA button on the Faire Direct Marketplace banner to show the user more details about the incentive via the modal.",
            img: "https://cdn.faire.com/fastly/6b2f577fbe580fcd4c44f08402290157df9640931c646828959846d9da580926.png",
          },
        })}
      </Button>
    </Typography>
  );
};
